module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("ONE")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I SUPPOSE HE must have died during the night, but I only became aware of it in the heat of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that it made much difference, not even the stench of putrefaction. In that place everything died except me, Stacey Wyatt, the great survivor. There had been times when I would have greeted death as a friend, co-operated with him actively, but that was long ago—too long. Now, I waited in a limbo of my own devising, proof against all they could do to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d been in the Hole for three days now, which was what it was called by prisoner and guard alike—a place of darkness and furnace heat where you rotted in your own filth and died from lack of air.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("It was the fourth time I’d been put down since they’d brought me to the labour camp at Fuad, each dose coinciding with one of Major Husseini ’s inspections. In the June war he had been one of the thousands whipped in Sinai and left to stumble home through one of the worst deserts on earth. He had seen his command crumble, men die around him by the hundred from thirst and the sun had burned its way into his brain, starting a fire that could never be put out, leaving him with a hatred for Israel which had developed into a kind of paranoia.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He seemed to see Jews everywhere, a constant threat to Egypt’s safety. As I was an enemy of his country, tried and convicted by law of subversive activities, I too must be a Jew who had somehow managed to conceal the fact from the court.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The previous July I’d brought a forty-foot launch in from Crete with gold bullion for a gentleman from Cairo who was supposed to meet me on a beach at Râs el Kanâyis, part of a complicated exchange process by which someone, somewhere, finally made a fortune. I never did find out exactly what went wrong, but a couple of U.A.R. gunboats appeared rather inconveniently, plus a half company of infantry on the beach. The economy benefited to the extent of half a ton of gold and John ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Smith, this year’s unknown American citizen, went down for seven years.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("After six months in a city gaol they transferred me to Fuad, a fishing village ninety miles from Alex. There were about thirty of us there, mostly political offenders condemned to work on the roads in chain gangs, although in this case we were building a new pier. We were guarded by half a dozen peasant conscripts and a civilian overseer called Tufik, a large, fat man who sweated a lot and smiled all the time. He had two wives and eight children and treated us with remarkable gentleness under the circumstances, although I think he was due a bonus if we finished by the end of July, which meant that he needed all the labour he could get and didn’t want anyone to die on him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man who had gone to a happier place during the night had been a special case, a Bedu from the south who had repeatedly tried to escape, a fierce, proud animal who had never slept under a roof in his life. For him, any kind of prison had been an automatic death-sentence and everyone had known that, even Tufik. But there was general camp discipline to consider and he’d gone into the Hole to encourage the others. He’d already been there a week when I joined him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("I was wearing a kind of wooden halter pad ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("locked around the neck, my wrists chained to it at shoulder level. It was impossible to lie down or even to stand, for if I tried within those narrow confines the ends of the halter caught against the rough walls, jarring my neck painfully. So I sat there in the heat, floating in my own dark limbo, reading my favourite books page by page, an excellent mental exercise, or when that palled, returning to the next phase of a monumental and highly personal course of self-analysis. I had started with childhood, the earliest memories—Wyatt’s Landing ten miles from Cape Cod and my father’s family who had never liked me although I hadn’t realised that fact until his death in Korea in nineteen fifty-three when I was ten. It was only afterwards that it was made plain that the Wyatt blood in me was tainted, for my mother was Sicilian. So to Sicily we went, to the great cool villa on the cliffs above the sea outside Palermo, to my grandfather, Vito Barbaccia, to whom men touched their hats, who ordered the police from here to there like chessmen, who scowled and made the politicians tremble.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Vito Barbaccia, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("capo mafia")]), _vm._v(", Lord of Life and Death …")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("I was working my way through my freshman year at Harvard when there was a sudden banging ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("above my head, a chain rattled, and from the scraping I knew that the stones were being pulled away. When the wooden trap was lifted, the sunlight flooded in, momentarily blinding me. I closed my eyes, blinked and looked through a soft, golden haze that told me it was late afternoon.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Major Husseini crouched at the edge, small and wizened, dried up by the Sinai sun that had deranged him, his olive face pitted from the smallpox. A couple of soldiers stood beside him and Tufik was there looking distinctly unhappy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Jew,” Husseini said in English, for although my Arabic had understandably improved over the past ten months, he considered it an insult to use the language of his fathers with someone like me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stood up and laughed contemptuously. “Look at him.” He gestured to the others. “Squatting in his own excrement like an animal.” He looked down at me again. “Do you like that, Jew? You like to sit there smeared with your own dung?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not so bad, major,” I told him in Arabic. “A monk once asked Bodidharma, what is Buddha? The master replied dried dung.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared down at me in a kind of bewilderment, so perplexed that he momentarily lapsed into Arabic himself. “What are you talking about?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“You’d need brains to make sense of it.”")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The trouble was that as I’d used Arabic, they all understood. The skin tightened across his cheeks and the eyes contracted. He turned to Tufik.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have him up. Hang him in the sun for a while. I’ll deal with him when I get back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something to look forward to,” I said, and for some reason started to laugh weakly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There wasn’t much to Fuad; forty or fifty small flat-roofed houses around a wide square, a crumbling mosque, no more than a couple of hundred inhabitants. It was miserably poor like most of these Egyptian villages, although the new pier was supposed to change all that. The sea was about four hundred yards away, the blue Mediterranean. Nice to be beside if you were on the beach at Antibes. I got a quick glimpse of it before they removed my halter and strung me by the wrists from a kind of wooden gallows in the centre of the square.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("It was supposed to be painful and would have been under normal circumstances, but I had been through so much during those past months that pain in itself meant very little to me any longer. In the heat of the day it would have been unpleasant, but not now in the late afternoon. In any case I had discovered, from past experience, that by focusing ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("on some object in the middle distance, a kind of self-hypnosis could be induced that made two or three hours seem considerably less.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Beside the guard post, a United Arab Republic flag drooped from a white-painted flagstaff, and beyond three men and a boy were driving a flock of several hundred sheep in from the desert. The thick cloud of dust raised by their hooves was blown towards the village like spreading smoke and the flag listed momentarily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was all very biblical, very Old Testament except that one of the shepherds carried an automatic rifle which proved something although I wasn’t sure what. God, but I was dry. I closed my eyes and breathed deeply for a while. When I opened them again nothing had changed. The same square, the same squalid little houses, the same uncanny lack of people. They had sense and were staying indoors while Husseini was around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tufik emerged from his office with a canteen of water and crossed towards me, sweat springing from every pore. It was an effort for him to scramble up on to the old packing case that the two guards had stood on when stringing me up, but he made it and forced the neck of the canteen between my teeth. He gave me a short swallow and poured the rest over my head.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“You will be reasonable. Mr. Smith, when he returns. Promise me that. It will only be worse for you if you annoy him further.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared at me anxiously, mopping his face with a soiled handkerchief. I was intrigued. For one thing, he’d called me mister, certainly the first time that had happened, and he was worried about me—too worried. It didn’t really make sense, but Husseini arrived before I could take it further.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His Land-Rover scattered the sheep a hundred yards on the other side of the village and braked to a halt outside the guard post. Husseini got out and came towards me. He stood perhaps ten yards away, staring up at me, his eyes full of hate, then turned abruptly and went into the guard post.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sheep arrived, flooding in between the houses, spilling across the square as they pushed towards the pool on the far side. The boy I had noticed earlier was perhaps ten or eleven, small and dark and full of energy, running up and down whistling and flapping his arms in the air to keep them on the move. His three companions were typical Bedu in shabby robes, each man with his burnous folded across his face as a protection against the heavy dust raised by the sheep.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("They passed by, heads down, pushing the flock hard, minding their own business, bells clanking in ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("the stillness. It was very quiet, the sun half-way below the horizon now. Another thirty minutes and the gang would be returning from the pier and their day’s work.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The sheep were at the water, fighting each other for the best positions and the shepherds squatted against a wall watching them. The door of the guard post opened and Husseini emerged and came towards me, the two soldiers at his heels. When they cut me down, I collapsed in a heap on the ground. He said something or other, I couldn’t quite catch what it was, and they picked me up between them and followed him across the square to Tufik’s place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fat man lived alone except for some old woman who came in each day to cook and wash for him, and the house he had commandeered doubled as an office. There was a roll-top desk, two wooden chairs and a table. Husseini barked an order and the two soldiers sat me on one of the chairs and bound my arms firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was then that I noticed his whip, real rhino from the look of it, guaranteed to take the flesh from a man’s spine. He took off his tunic and started to roll up his sleeves very carefully. Tufik looked frightened to death and sweated more than ever. The two soldiers stood against the wall and Husseini picked up the whip.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“Now, Jew,” he said, bending it like a bow in his two hands. “To start with, a dozen. After that we shall see.”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Major Husseini,” a voice said softly in English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Husseini turned sharply and I lifted my head. Beyond him in the doorway stood one of the shepherds. His right hand went to his burnous, pulling it away, revealing a tanned, wedge-shaped face and the kind of mouth that looked as if it might twist into a smile at any moment, but seldom did, grey eyes, cold as water over stone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sean?” I croaked. “Sean Burke? Could that be you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As ever was, Stacey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His left hand came out of his robe holding a Browning automatic. His first shot took Husseini in the shoulder, twisting him round so that I looked into his face as he died. The second blew away the back of his head, driving him past me and into the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two soldiers stared stupidly, eyes widening in horror, their rifles still slung from their shoulders and died that way as a machine pistol smashed through the window and cut them down in two long bursts.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("There was a kind of silence and Tufik was the first to speak, the words falling over themselves to ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("get out. “I was worried, terribly worried. I thought you weren’t coming, that something might have gone wrong.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Burke ignored him. He came forward slowly and leaned over me. “Stacey?” he said and touched my cheek gently with his left hand. “Stacey?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was pain on his face, something I had never seen before, and then that terrible killing rage for which he was so notorious. He turned on Tufik.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What have you done to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tufik’s eyes widened. “What have I done, Effendi? But I am the one who has made all this possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve just decided I don’t like your prices.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Browning swept up, Tufik cried out in fear and cowered in the corner. I shook my head and said weakly, “Leave him alone, Sean, he could have been worse. Just get me out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a momentary hesitation and then the Browning disappeared inside the robe. Tufik slid down on to his knees and started to cry weakly.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("I might have known who the other two would be. Piet Jaeger, the South African, one of the few survivors of our old company in the Katanga campaign, and Legrande, the ex O.A.S. man Burke had ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("recruited in Stanleyville when we had reformed. Jaegar was driving Husseini’s Land-Rover and Legrande helped Burke lift me into the back seat. Nobody said very much and there was obviously some kind of time-table in operation.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Fuad was still quiet as the grave when we drove out along the so-called coast road, passing the column of prisoners marching in from their day’s work on the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You haven’t got long,” I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Burke nodded. “We’re dead on time. Don’t worry.”\t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A mile further on, Jaeger swung off the road and took us through sand dunes to the edge of a broad flat beach. As he switched off the motor another sound filled the air and a plane came in off the sea no more than two or three hundred feet above the surface of the water. Legrande produced a Verey pistol and fired a flare and the plane turned sharply and dropped in for a perfect landing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a Cessna, I recognised that much as it taxied towards us, but there was no time to stand around. They hustled me forward as the cabin door swung open and pushed me inside. The others followed and as Legrande fastened the door the Cessna was already turning into the wind, her engine note deepening.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Burke held a flask to my mouth and I choked as brandy burned its way into my stomach. When the coughing had subsided, I smiled weakly. “Where to now, colonel?”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“First stop Crete,” he said. “We’ll be there in an hour. Good thing, too. You could do with a bath.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took the flask from him and swallowed again and leaned back in my seat as a warm and wonderful glow spread throughout my body. Life began again, that was all I could think of. As the Cessna lifted into the air and turned out to sea, the sun died behind the horizon and night fell.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3bd7a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter01.vue
// module id = 63
// module chunks = 0